module.exports = __webpack_public_path__ + "static/media/web_page.2d582d27.jpg";